<template>
   <div class="appbox">
      <router-view ></router-view>
      <!-- <drag @handlepaly="handleaudioplay" style="cursor:pointer"></drag> -->
      <!-- <van-tabbar v-model="active">
  <van-tabbar-item icon="home-o">首页</van-tabbar-item>
  <van-tabbar-item icon="search" dot>运动之星</van-tabbar-item>
  <van-tabbar-item icon="friends-o" info="5">积分商城</van-tabbar-item>
  <van-tabbar-item icon="setting-o" info="20">个人中心</van-tabbar-item>
</van-tabbar> -->
      <!-- <div class="aibox" @click="toAI"></div> -->
   </div>
</template>



<script >
import drag from './components/drag.vue';
//   import WeixinJSBridge from 'weixin-js-sdk';

// //Android微信中，借助WeixinJSBridge对象来阻止字体大小调整
// (function() {
//   console.log(window.WeixinJSBridge.invoke);
//   console.log(WeixinJSBridge,'WeixinJSBridge',typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function");
// if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
// handleFontSize();
// } else {
// if (document.addEventListener) {
// document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
// } else if (document.attachEvent) {
// //IE浏览器，非W3C规范
// document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
// }
// }

// function handleFontSize() {
//   console.log(WeixinJSBridge,'WeixinJSBridge');
//    // 设置网页字体为默认大小
// WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
// // 重写设置网页字体大小的事件
// WeixinJSBridge.on('menu:setfont', function() {
// WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
// });
// }
// })()
// This starter template is using Vue 3 experimental <script setup> SFCs
// Check out https://github.com/vuejs/rfcs/blob/script-setup-2/active-rfcs/0000-script-setup.md
export default {
  components: {
    drag
  },
  data () {
    return {
      active: 0
    }
  },
 mounted() {
    const handleFontSize = () => {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke('setFontSizeCallback', {fontSize: 0});
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on('menu:setfont', function() {
        WeixinJSBridge.invoke('setFontSizeCallback', {fontSize: 0});
      });
    };
    try {
      // 安卓 禁止用户自定义设置字体大小
      if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
        handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', handleFontSize);
          document.attachEvent('onWeixinJSBridgeReady', handleFontSize);
        }
      }
    } catch (error) {}
  },
  methods: {

    handleaudioplay() {
      this.$router.push({path:'/AIConversation'})

    },
    toAI(){
    }

  }
}


</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 12px;
  /* margin-top: 60px; */
}
.appbox{
  /* position: relative; */
  overflow: scroll;
  height: 100vh;

}
.aibox{
  position: fixed;
  bottom: 100px;
  right: 40px;
  background: #1debd9;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 50%;
  background-image: url("./assets/background/loginLog.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
}
</style>
<style lang="less">
/* ======= 以下样式需要全局引入或在 App.vue scoped 中引入 ======= */

/* 1. Dialog 重构为苹果标准风格 */


/* 2. 重构 Toast Loading 变清爽 */

/* 3. Notify 样式重构为药丸状悬浮 */
.van-notify {
  width: auto !important;
  left: 20px !important;
  right: 20px !important;
  top: 15px !important;
  border-radius: 100px !important; /* 药丸 */
  box-shadow: 0 4px 16px rgba(0,0,0,0.15) !important;
  padding: 10px 18px !important;
  font-weight: 500 !important;
  justify-content: center !important;
}

/* 定义进出动画 */
.fade-slide-enter-active {
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1); /* 平滑苹果动画 */
}
.fade-slide-enter {
  opacity: 0;
  transform: translateY(15px);
}
</style>